'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"
import router from "@/router";

export default {
    async getDeductions(id) {
        const data = {
            method: 'get',
            url: 'casual-deductions/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async createDeduction(json) {
        const data = {
            method: 'post',
            url: 'casual-deduction',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Deduction created successfully')
            return true;
        }
    },
    async updateDeduction(json, id) {
        const data = {
            method: 'patch',
            url: 'casual-deduction/' + id,
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Deduction updated successfully')
            return true;
        }
    },
    async deleteDeduction(id) {
        const data = {
            method: 'delete',
            url: 'casual-deduction/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Deduction deleted successfully')
            return true;
        }
    },
}
